import { useQuery } from '@tanstack/react-query';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

import { User } from '../models/client.types';
import { userService } from '../services/user.service';
import { userState } from '../store/user.store';

export function useUser() {
  const { data: session } = useSession();
  const userId = session?.user?.id;

  const {
    data: user,
    isLoading,
    error,
    refetch,
  } = useQuery<User | null>({
    queryKey: ['user-profile', userId],
    queryFn: async () => {
      if (!userId || !session) return null;
      return userService.getUser(userId, session);
    },
    enabled: !!userId,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  // Sync user data with Legend state store
  useEffect(() => {
    if (user) {
      userState.profile.set({
        data: user,
        isLoading: false,
        error: null,
      });
    }
  }, [user]);

  return {
    user,
    isLoading,
    error,
    refetch,
    isAdmin: user?.isAdmin ?? false,
    isSubscribed: user?.isSubscribed ?? false,
    isLawyer: user?.role === 'lawyer' || false,
  };
}
